// Content for Swede's Wood — dark logo cover + bright topic gallery

export const LOGO =
  "/photos/pldiizbu_swedeswood_high_res_front.jpg";

// Business contact details (phone hidden for now — set phone to a value to show it again)
export const CONTACT = {
  name: "Swede's Wood",
  email: "swede@swedeswood.com",
  location: "Overland Park, Kansas 66212",
  phone: "",
};

// The maker — rendered as a personal closing section + a cover link
export const MAKER = {
  id: "meet-swede",
  label: "Meet Swede",
  name: "Kelly \u201CSwede\u201D Hagen",
  photo: "/photos/dbr3rhve_IMG_4843.jpg",
  signPhoto: "/photos/thankful-sign.jpg",
  bio: [
    "Hi, I'm Kelly \u2014 most folks just call me Swede. Swede's Wood is my workshop in Overland Park, Kansas.",
    "I build everything here by hand, mostly from storm-fallen trees I'd hate to see end up in a landfill, and finish it all in non-toxic oils that are safe around your family and pets.",
    "If you can picture it, there's a good chance we can build it. Reach out and let's talk it through.",
  ],
};

// Order intentionally runs smaller/simpler -> larger/bigger.
export const TOPICS = [
  {
    id: "storm-sourced",
    label: "Storm-Sourced",
    paragraphs: [
      "This is some pecan wood we harvested from a storm-damaged tree. It will be sawn up and dried for many uses \u2014 flooring, or perhaps outdoor furniture.",
      "Look closely and you'll find a piece that resembles a heart. That one will become something artful. It's the whole idea behind Swede's Wood: rescue the fallen, and let the grain decide what it wants to be.",
    ],
    photos: [
      { src: "/photos/alrcde79_IMG_6307.webp", time: "Heart Piece", alt: "Freshly cut pecan slab with a heart-like grain figure" },
      { src: "/photos/dwlj86xm_IMG_6311.webp", time: "Storm-Fallen", alt: "Heart-shaped pecan round destined to become yard art" },
      { src: "/photos/zvpo9msb_IMG_6312.webp", time: "Storm-Fallen", alt: "Heart-shaped pecan slab from the storm-damaged tree" },
      { src: "/photos/avivnex3_IMG_6309.webp", time: "Storm-Fallen", alt: "Round pecan cross-section drying in the sun" },
      { src: "/photos/kjuchzry_IMG_6310.webp", time: "Heart Piece", alt: "Pecan log cross-section showing tight growth rings" },
      { src: "/photos/pecan-trailer.jpg", time: "Fresh Haul", alt: "These pecan logs are headed to the bandsaw mill and then to the dryer. Eventually these logs are destined to become T&G flooring in our home." },
    ],
  },
  {
    id: "yard-art",
    label: "Yard Art",
    paragraphs: [
      "These are artful placements to highlight a bright and sunny disposition in areas of the yard.",
      "Each sunflower is hand-painted on reclaimed and storm-fallen wood, so no two boards \u2014 or blooms \u2014 are ever quite the same.",
      "These are a seasonal item and will change throughout the year for the prevailing season.",
    ],
    photos: [
      { src: "/photos/86hj941s_730354000_1737297657267610_6486827227664476964_n.jpg", time: "Handmade", alt: "Starburst wall art made from vintage hand saws around a circular blade" },
      { src: "/photos/sunflower-panels.jpg", time: "Handmade", alt: "Three sunflower shutter panels in black, white, and red" },
      { src: "/photos/5k7bueel_sunflower_4_.webp", time: "Handmade", alt: "Hand-painted sunflower on a reclaimed wood panel" },
      { src: "/photos/kq5gnixy_sunflower_1_.jpg", time: "Handmade", alt: "Tall sunflower plank yard art" },
      { src: "/photos/q7llgbx0_sunflower_2_.jpg", time: "Handmade", alt: "Sunflower 'hello' welcome plank on a porch" },
      { src: "/photos/trgmnbh2_sunflower_3_.jpg", time: "Handmade", alt: "Painted sunflower board displayed indoors" },
    ],
  },
  {
    id: "interior-enhancements",
    label: "Interior Enhancements",
    paragraphs: [
      "A few of the smaller things that bring the workshop indoors \u2014 live-edge trays and boards, one-of-a-kind lamps, and pieces that turn a raw slab into something you'll reach for every day.",
      "From a serving tray with the bark left on to a lamp lit from inside the grain, these are the finishing touches that make a house feel handmade.",
    ],
    photos: [
      { src: "/photos/coat-rack.jpg", time: "Entry Piece", alt: "Driftwood coat and bag tree for the entry" },
      { src: "/photos/moon-mirror.jpg", time: "Lit Mirror", alt: "Backlit live-edge crescent-moon wall mirror" },
      { src: "/photos/entry-bench.jpg", time: "Entry Bench", alt: "Sculptural live-edge entry bench" },
      { src: "/photos/log-floor-lamp.jpg", time: "Log Lamp", alt: "Live-edge log floor lamp with a glowing hollow in a cozy library" },
      { src: "/photos/ucxhm2mm_IMG_7141.jpg", time: "Lit Board", alt: "Walnut serving board with a glowing Lichtenberg lightning figure" },
      { src: "/photos/ay1r9d4u_IMG_7123.jpg", time: "Lamp", alt: "Sculptural driftwood table lamp with a warm Edison bulb" },
      { src: "/photos/v14gv82u_IMG_7147.jpg", time: "Floor Lamp", alt: "Tall live-edge floor lamp with a warm glowing seam" },
      { src: "/photos/walnut-tray-2.jpg", time: "Serving Tray", alt: "Live-edge walnut serving tray with bark edges and handles" },
      { src: "/photos/cat-key-holder.jpg", time: "Key Rack", alt: "Cat-family wall key holder shelf with hooks" },
    ],
  },
  {
    id: "lighting",
    label: "Garden & Pathway Lighting",
    paragraphs: [
      "Low, warm light for the garden and along the path \u2014 designed to flatter the space and guide the way without ever glaring.",
      "From solar bollards to hanging lanterns, every fixture is hand-built in wood and set just so, turning a walkway or patio into a place you'll linger long after the sun goes down.",
    ],
    photos: [
      { src: "/photos/pathway-bollard.jpg", time: "Bollard", alt: "Tall wood bollard light with a warm glowing slot among ornamental grasses" },
      { src: "/photos/rodov97e_IMG_6377.jpg", time: "Solar", alt: "Solar timber bollard casting a warm downward glow along the path" },
      { src: "/photos/xuvurr4x_IMG_6375.jpg", time: "Solar", alt: "Tapered cedar path light with a soft inner glow" },
      { src: "/photos/ggvv4mb7_IMG_6374.jpg", time: "Night", alt: "Timber bollard lantern glowing under the stars" },
      { src: "/photos/03z3zva3_IMG_5517.jpg", time: "Evening", alt: "Rustic timber post with a hanging lantern at dusk" },
      { src: "/photos/75sptnj5_IMG_5625.jpg", time: "Garden", alt: "Craftsman post with a hanging candle-lantern among the flowers" },
    ],
  },
  {
    id: "benches",
    label: "Benches & Chairs",
    paragraphs: [
      "Benches and chairs, hand-built to gather around and made to weather the seasons \u2014 from modern Adirondacks to solid-timber garden benches.",
      "Every piece is custom and finished in non-toxic oils, built to outlast the big-box alternatives and become the spot everyone chooses first.",
    ],
    photos: [
      { src: "/photos/bench-timber-peg.jpg", time: "Timber Bench", alt: "Chunky solid-timber bench with exposed peg joinery" },
      { src: "/photos/uoyq4uoy_IMG_6398.jpg", time: "Chair", alt: "Modern Adirondack chair in teak on a brick patio" },
      { src: "/photos/wsos7kp5_IMG_6397.jpg", time: "Settee", alt: "Modern Adirondack loveseat settee with a side table" },
      { src: "/photos/i678jr1v_IMG_6471.jpg", time: "Bench", alt: "Solid timber garden bench with a backrest" },
      { src: "/photos/hlw80gfx_IMG_6470.jpg", time: "Planter Bench", alt: "Slatted bench with a built-in planter box" },
      { src: "/photos/0qfvgmsj_IMG_6479.jpg", time: "Beam Bench", alt: "Reclaimed timber-beam bench with blackened top and joinery" },
    ],
  },
  {
    id: "privacy-screening",
    label: "Privacy Screening",
    paragraphs: [
      "Privacy screening is one of the most-requested additions to a space \u2014 a clean way to tuck away an AC unit, a window, or a neighbor's sightline without walling yourself in.",
      "We build them fixed or with adjustable louvers, freestanding or wall-mounted, and sized to the exact spot \u2014 so you get just the light and airflow you want, and none of the view you don't.",
    ],
    photos: [
      { src: "/photos/privacy-planter-screen.jpg", time: "With Planter", alt: "Cedar slat privacy screen with a black frame and built-in planter box" },
      { src: "/photos/louvered-privacy-screen.jpg", time: "Adjustable Louvers", alt: "Freestanding privacy screen with adjustable louvered slats" },
      { src: "/photos/x74e2afg_IMG_5912.jpg", time: "Fixed", alt: "Horizontal cedar slat privacy screen over a window" },
      { src: "/photos/9u0irlq6_IMG_5904.jpg", time: "Wall-Mounted", alt: "Wall-mounted slat screen shading a side window" },
      { src: "/photos/53scmaga_IMG_5050.jpg", time: "Freestanding", alt: "Cedar slat screen concealing an air-conditioning unit" },
      { src: "/photos/privacy-black-slat.jpg", time: "Room Divider", alt: "Black slat freestanding privacy screen on a metal base" },
    ],
  },
  {
    id: "arbors",
    label: "Arbors",
    paragraphs: [
      "An arbor is where the garden pauses to greet you. We build ours from a variety of storm-fallen woods and cedars sourced from all over the country. Some of our cedars are taken from fire-ravaged areas that have killed the tree but left enough for us to salvage for many of the beautiful things you see here on our site.",
      "The style adapts to how you live \u2014 span it over a walkway with a trellis panel for climbing roses, or set it above a hanging swing for a shaded place to sit and enjoy the outdoor breeze. We build it to fit your space and your tastes. You pick the design that makes you happy and we're happy to build it for you.",
    ],
    photos: [
      { src: "/photos/29qjkb86_IMG_5973.jpg", time: "Custom", alt: "Wooden pergola arbor with a hanging porch swing" },
      { src: "/photos/6ojd2olm_IMG_6381.jpg", time: "Custom", alt: "Cedar arbor with trellis panels over a paver walkway" },
      { src: "/photos/arbor-fence.jpg", time: "Custom", alt: "Cedar pergola arbor with hanging baskets creating a secluded spot along the fence" },
    ],
  },
  {
    id: "trellises",
    label: "Trellises",
    paragraphs: [
      "A trellis gives your garden something to reach for. Hand-built to weather gracefully, each one is sized to your space, your fence line, or a favorite corner.",
      "Beans, clematis, ivy, grapes \u2014 whatever you plant, the lattice does the quiet work of turning a flat space into a living one.",
    ],
    photos: [
      { src: "/photos/trellis-6594.jpg", time: "Sunburst", alt: "Cedar sunburst fan trellis under a pergola over a flower bed" },
      { src: "/photos/trellis-6596.jpg", time: "Grapevine", alt: "Grid trellis with climbing grapevines against a house" },
      { src: "/photos/kn21cfk4_f68cd22efd3775e88526179d438581e8.jpg", time: "Roses", alt: "Twin wall trellises with climbing roses framing a lantern" },
      { src: "/photos/cfkplttr_ca299bdb37cbd3ee85ab37522383cd1c.jpg", time: "Lattice", alt: "Lattice trellis panel set beneath a garden pergola" },
      { src: "/photos/lqkxwn7i_d3809166d3276b1a1ff4a73b0439be59.jpg", time: "Garden", alt: "Trellis-sided arbor over a blooming garden bed" },
      { src: "/photos/vf4s5ary_f34cbd05c9a7be12f15b7a8599f8ee51.jpg", time: "Arbor", alt: "Arched arbor with lattice trellis sides and built-in planters" },
    ],
  },
  {
    id: "outdoor-metal-art",
    label: "Outdoor Metal Art",
    paragraphs: [
      "Not everything we make is wood. These weathering-steel (Corten) sculptures are built to live outside, taking on a warm, rust-toned patina that only deepens with the seasons.",
      "From stacked-cube totems and bold abstract forms to a curved arch of resonant chimes, each is a one-off statement piece sized for a garden bed, a gravel court, or the end of a path.",
    ],
    photos: [
      { src: "/photos/metal-double-heart.jpg", time: "Double Heart", alt: "Corten steel double-heart sculpture set in a sunny tree stump" },
      { src: "/photos/elo3jws3_IMG_7036.jpg", time: "Totem", alt: "Stacked-cube Corten steel totem in a garden bed" },
      { src: "/photos/gkkenax0_IMG_7044.jpg", time: "Totem", alt: "Twin-column offset Corten steel sculpture" },
      { src: "/photos/5bxgto42_IMG_7037.jpg", time: "Sculpture", alt: "Angular abstract weathering-steel sculpture" },
      { src: "/photos/cyxccjma_IMG_7056.jpg", time: "Sculpture", alt: "Corten ribbon sculpture on a concrete plinth amid succulents" },
      { src: "/photos/rb7enc6e_IMG_7063.jpg", time: "Chimes", alt: "Curved Corten arch with two hanging bell chimes" },
    ],
  },
  {
    id: "materials-ready",
    label: "Materials Ready for that Next Project",
    paragraphs: [
      "Some ready-to-go timbers for the next project. We keep a stash of reclaimed heavy beams and dimensional stock \u2014 sorted, stacked, and waiting for the right build.",
      "Bring us your idea and there's a good chance the wood for it is already here.",
    ],
    photos: [
      { src: "/photos/timber-reclaimed-stack.jpg", time: "Ready Stock", alt: "Reclaimed heavy timbers stacked and ready in the shop" },
      { src: "/photos/timber-sorted-stack.jpg", time: "Ready Stock", alt: "Sorted salvaged beams waiting for the next project" },
      { src: "/photos/timber-fir-beams.jpg", time: "Ready Stock", alt: "Douglas fir beams laid out for a new build" },
    ],
  },
];
